module.exports = __webpack_public_path__ + "static/media/spinner.9d946be5.png";